import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';

import { FormGroup, FormBuilder, Validators, NgForm, FormArray } from '@angular/forms';
import { NgbDateStruct, NgbModal, NgbModalRef, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { NotificationService } from '../../../services/notification.service';
import { CourseService } from '../../../services/course.service';
import { CourseWorkUtilityService } from '../../../services/course-work-utility.service';
import { PassionProjectService } from 'src/app/services/passion-project.service';
import { Roles } from 'src/app/auth/roles.enum';
import { HeaderService } from 'src/app/services/header.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-mentors',
  templateUrl: './select-mentors.component.html',
  styleUrls: ['./select-mentors.component.scss']
})
export class SelectMentorsComponent implements OnInit, OnDestroy {

  @Input() tags: string[] = [];
  @Input() viewItemId: string = '';
  @Input() btnRef: string = '';
  @Input() teamData: any = {};
  @Input() recommendedLoading: boolean = false;
  @Input() recommendedMentors: any[] = [];
  @Output() teamStatus = new EventEmitter<any>();

  //FOR STUDENT COURSE WORK
  loader: boolean = false;
  courseName: string = '';
  courseId: string = '';
  courseWorkId: string = '';
  topicId: string = '';
  courseworks: any = {};
  courseData: any = {};
  courseTitle: string = '';
  isTopicCoursework: boolean = false;	
  
  //FOR TEAM
  groupProcessing: boolean = false;
  courseworkTeaminfo: any = [];
  userDefaultPic: string = environment.imageBasePath + environment.userDefaultProfilePic;
  createGroupModal: NgbModalRef;
  addTeamByStudnet: FormGroup;
  subscribeStudentList: any = [];
  addedMembers: any = [];
  resetTeam: boolean = false;
  groupActionName = 'Create';
  editTeamData: any[] = [];
  uploadedImg: string = '';
  resourcePath: string = '';
  loggedInUserId: string = '';
  defaultSubscriber: any = {};
  showCreateGroup: boolean = false;

  role: string = '';
  avatar: string = '';
  username: string = '';
  fullName: string = '';
  resourceModuleName: string = 'passion_project';
  searchText: string = '';
  isSearchEnabled: boolean = false;
  leadMember: any = {};
  isISDMOrg: boolean = false;
  private orgLogoSub?: Subscription;

  readonly ROLE_STUDENT = Roles.STUDENT;
  readonly ROLE_MENTOR = Roles.MENTOR;

  //FOR SELECT MENTORS
  @ViewChild('createGroup', { static: true }) createGroup: any;

  constructor(private modalService: NgbModal, private fb: FormBuilder, private notificationService: NotificationService, private courseService: CourseService, private cwUtilityService: CourseWorkUtilityService, private passionProjectService: PassionProjectService, private router: Router, private headerService: HeaderService) { }

  ngOnInit() {
  	this.role = localStorage.getItem('role');
    this.loggedInUserId = localStorage.getItem('user_id');
    this.fullName = localStorage.getItem('first_name');
    this.username = localStorage.getItem('currentUser');
    this.avatar = localStorage.getItem('avatarURL');
    this.orgLogoSub = this.headerService.orgLogo.subscribe((logoData: any) => {
      this.isISDMOrg = logoData && logoData.organizationSubDomain ? logoData.organizationSubDomain.toLowerCase() === 'isdm' : false;
    });

    //FOR SELECT MENTORS
    this.createForm();
    if(this.btnRef == 'Create') {
      this.openGroupCreateModel(this.createGroup, 'Create');
    }
  }

  ngOnDestroy() {
    if (this.orgLogoSub) {
      this.orgLogoSub.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.recommendedMentors && this.activeTab === 'recommended') {
      this.disableRecommendedSubscribers();
      this.filteredRecommendedMentors = [...this.recommendedMentors];

      if (this.searchText) {
        this.filterRecommended(this.searchText);
      }
  }

    if('teamData' in changes && changes['teamData'].firstChange == false) {
      if(this.btnRef == 'Edit') {
        this.teamData = this.teamData.map((item) => {
          item._id = item.id;
          item.name = item.first_name + ' ' + item.last_name;
          item.username = item.user_name;
          return item;
        });
        this.openGroupCreateModel(this.createGroup, 'Edit');
      }
    }
  }

  filteredRecommendedMentors: any[] = [];

  get displayedMentorList() {
    return this.activeTab === 'recommended'
      ? this.filteredRecommendedMentors
      : this.subscribeStudentList;
  }


  activeTab: 'all' | 'recommended' = 'recommended';

  onTabSwitch(tab: 'all' | 'recommended') {
    this.activeTab = tab;

    if (tab === 'recommended') {
      this.disableRecommendedSubscribers();
      this.filterRecommended(this.searchText);
    } else {
      if (this.searchText.length > 0) {
        this.getSubscribeStudent(this.groupActionName);
      }
    }
  }

  //disable recommended mentors who are already added
  disableRecommendedSubscribers() {
    if (!this.recommendedMentors || !this.recommendedMentors.length) return;

    // reset
    this.recommendedMentors.forEach(item => {
      item.isAdded = false;
    });

    // mark already selected
    this.addedMembers.forEach(selected => {
      const recUser = this.recommendedMentors.find(
        r => r._id === selected._id
      );
      if (recUser) {
        recUser.isAdded = true;
      }
    });

    this.filteredRecommendedMentors = [...this.recommendedMentors];
  }



filterRecommended(term: string) {
  const value = term.toLowerCase().trim();

  if (!value) {
    this.filteredRecommendedMentors = [...this.recommendedMentors];
    return;
  }

  this.filteredRecommendedMentors = this.recommendedMentors.filter(m => {
  const name = m.name ? m.name.toLowerCase() : '';
  const username = m.username ? m.username.toLowerCase() : '';

  return (
    name.includes(value) ||
    username.includes(value)
  )
  });

}

  //CREATE AND EDIT TEAM |START
  createForm(): void {
    this.addTeamByStudnet = this.fb.group({
      name: [""],
      userlist: [""],
    });
  }

  //FOR UPLOAD TEAM PICTURE |START
  onSelectFile(event) {
    let files = event.target.files;
    //console.log(files);
    if (files.length) {
      const fileSize = files[0].size / 1024 / 1024;
      const limitSize = environment.groupProfilePicSize;
      if (fileSize > limitSize) {
        this.notificationService.showNotification('info', 'File size exceeds ' + limitSize + ' MB');
        return;
      }
      this.uploadGroupPic(files[0]);
    }
  }

  onFileInputClick(event) {
    event.target.value = null;
  }

  uploadGroupPic(file) {
    this.groupProcessing = true;
    this.notificationService.upload_resource(this.resourceModuleName, file).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Response:
          const resourceData = response.body.resource_info[0];
          this.resourcePath = resourceData.path;
          this.uploadedImg = resourceData.url;
          this.groupProcessing = false;
          this.notificationService.showNotification('success', 'File uploaded successfully');
      }
    },
      (err) => {
        this.groupProcessing = false;
        this.notificationService.showNotification('info', 'Please add again not able to save your file');
      });
  }
  //FOR UPLOAD TEAM PICTURE |END

  openGroupCreateModel(content, formRef) {
    this.addedMembers = [];
    this.groupActionName = formRef;
    this.resourcePath = '';
    this.uploadedImg = '';

    //FOR CREATE GROUP    
    if(formRef == 'Create') {
      this.setInitialData(formRef);
    }

    //FOR EDIT GROUP
    if (formRef == 'Edit') {
      this.editTeamData = this.teamData;
      this.addTeamByStudnet.controls['name'].setValue('test');
      this.setInitialData(formRef);
    }
  }

  closeGroupCreateModel() {
    this.addedMembers = [];
    this.subscribeStudentList = [];
    this.searchText = '';
    this.isSearchEnabled = false;
    this.createForm();
    this.createGroupModal.close();
  }

  discardChanges() {
    this.addedMembers = [];
    this.setInitialData('Discard');
  }

  getSubscribeStudent(ref = '') {
    let role = this.ROLE_MENTOR;
    this.groupProcessing = true;
    this.passionProjectService.searchTeamMember(this.searchText, role).subscribe((response) => {
      this.subscribeStudentList = response;
      //console.log(this.subscribeStudentList);

      //FOR DISABLE SUBSCRIBER IF ALREADY ADDED
      this.disableSubscribers(ref);

      this.groupProcessing = false;
    }, err => {
      this.groupProcessing = false;
      this.handleError(err);
    });
  }

  setInitialData(ref) {

    //FOR EDIT GROUP
    if(this.groupActionName == 'Edit') {
      this.initSubscribers(ref);
    }

    if(this.groupActionName == 'Create') {
      //FOR ADD DEFAULT MEMBER
    }

    //FOR DISABLE SUBSCRIBER IF ALREADY ADDED
    this.disableSubscribers(ref);
  }

  disableSubscribers(ref) {
    if (ref == 'Create' || ref == 'Discard' || ref == 'Edit') {
      this.subscribeStudentList.forEach(item => {
        item.isAdded = false;
      });
      this.addedMembers.forEach(element => {
        let subscriberStudent = this.subscribeStudentList.find(subscriber => {
          return subscriber._id == element._id;
        });
        if(subscriberStudent) {
          subscriberStudent.isAdded = true;
        }
      });
    }
  }

  initSubscribers(ref) {
    if (ref == 'Edit' || ref == 'Discard') {
      this.editTeamData.forEach((elm) => {
        if(elm._id != this.loggedInUserId) {
          this.addedMembers.push(elm);
        }        
      });
    }
  }

  addDefaultMember(ref) {
    if (ref == 'Create' || ref == 'Discard') {
      let subscriberStudent = {avatar: this.avatar, id: this.loggedInUserId, institute_type: '', name: this.fullName, organisation_name: '', role: this.role, username: this.username, _id: this.loggedInUserId};
      
      this.defaultSubscriber = subscriberStudent;
      this.addMemberToGroup(subscriberStudent);
    }
  }

  addMemberToGroup(subscriberStudent) {

  const index = this.addedMembers.findIndex(
    addedMember => addedMember._id === subscriberStudent._id
  );

  if (index === -1) {
    // console.log('Member not in addedMembers, adding now.');
    this.addedMembers.push(subscriberStudent);
    subscriberStudent.isAdded = true;
  }

  // Sync recommended list
  this.recommendedMentors.forEach(m => {
    if (m._id === subscriberStudent._id) {
      m.isAdded = true;
    }
  });

  this.teamStatus.emit({ status: true, selectedMembers: this.addedMembers });
}

removeMemberFromGroup(member) {
  // Remove from added members
  const index = this.addedMembers.findIndex(
    addedMember => addedMember._id === member._id
  );
  if (index > -1) {
    this.addedMembers.splice(index, 1);
  }

  // Unmark in ALL mentors list (API list)
  const subscriber = this.subscribeStudentList.find(
    subscriberStudent => subscriberStudent._id === member._id
  );
  if (subscriber) {
    subscriber.isAdded = false;
  }

  // Unmark in RECOMMENDED mentors list
  this.recommendedMentors.forEach(m => {
    if (m._id === member._id) {
      m.isAdded = false;
    }
  });

  // Emit updated selection
  this.teamStatus.emit({
    status: true,
    selectedMembers: this.addedMembers
  });
}


  saveTeams() {
    const groupName = this.addTeamByStudnet.value.name.trim();

    if (!groupName) {
      this.notificationService.showNotification('info', 'You have not entered any team name please enter it.');
      return;
    }

    if (this.addedMembers.length == 0) {
      this.notificationService.showNotification('info', 'You have not added any member in the group.');
      return;
    }

    //PREPARE POST DATA
    let usersData = [];
    let actionLabel = 'created';
    if (this.groupActionName == 'Edit') {
      actionLabel = 'updated';
    }
    this.addedMembers.forEach(element => {
      usersData.push(element._id);
    });
    const finalData = { team_name: groupName, team_logo: this.resourcePath, team_members: usersData, project_id: [this.viewItemId] };
    // console.log(finalData);
    // return;

    this.groupProcessing = true;
    this.passionProjectService.addTeam(finalData, this.groupActionName, this.viewItemId).subscribe(getTeams => {
      this.notificationService.showNotification('success', 'Team '+ actionLabel +' successfully');
      this.addedTeam();
      this.groupProcessing = false;
    },
      (error) => {
        this.groupProcessing = false;
        this.notificationService.showNotification('error', error.message);
      });
  }

  addedTeam() {
    this.teamStatus.emit({status: true});
    this.closeGroupCreateModel();
  }
  //CREATE AND EDIT TEAM |END

  //FOR SEARCH USER |START
 onStartSearch(data) {
  this.searchText = data.searchText;

  if (this.activeTab === 'recommended') {
    this.filterRecommended(this.searchText);
    return;
  }

  // Existing ALL mentors behavior (unchanged)
  if (this.searchText.length > 0) {
    this.isSearchEnabled = true;
    this.getSubscribeStudent(this.groupActionName);
  } else {
    this.isSearchEnabled = false;
    this.searchText = '';
    this.subscribeStudentList = [];
  }
}

  //FOR SEARCH USER |END

  handleError(error) {
    this.notificationService.showNotification('error', error.message);
  }

  //FOR VIEW MENTOR PROFILE
  viewMentorProfile(mentor: any) {  
    const url = this.router.createUrlTree(['/mentorship/mentor-profile'],{ queryParams: { id: mentor._id } });

    window.open(url.toString(), '_blank');
  }

}
